import React, { useEffect, useRef } from 'react';

// Renders the launch-ready standalone Syntriem site: loads its CSS, injects the
// markup, restores the dashboard payload (decoded on login), and runs the
// interactive scripts. Assets live in /public/site.
export default function Site() {
  const containerRef = useRef(null);

  useEffect(() => {
    let cancelled = false;

    // 1) inject stylesheet once
    if (!document.getElementById('syntriem-site-css')) {
      const link = document.createElement('link');
      link.id = 'syntriem-site-css';
      link.rel = 'stylesheet';
      link.href = '/site/site.css';
      document.head.appendChild(link);
    }

    // 2) load body markup, then payload + scripts
    fetch('/site/body.html')
      .then((r) => r.text())
      .then((markup) => {
        if (cancelled || !containerRef.current) return;
        containerRef.current.innerHTML = markup;

        // 2a) restore the base64 dashboard payload element (read on login).
        // Fetched lazily so the landing page loads fast.
        if (!document.getElementById('syntriem-dashboard-payload')) {
          const payloadEl = document.createElement('script');
          payloadEl.type = 'application/octet-stream';
          payloadEl.id = 'syntriem-dashboard-payload';
          document.body.appendChild(payloadEl);
          fetch('/site/dashboard-payload.txt')
            .then((r) => r.text())
            .then((txt) => { payloadEl.textContent = txt.trim(); })
            .catch(() => {});
        }

        // 2b) run interactive scripts once
        if (!window.__syntriemScriptsLoaded) {
          window.__syntriemScriptsLoaded = true;
          const s = document.createElement('script');
          s.src = '/site/site.js';
          s.async = false;
          document.body.appendChild(s);
        }
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, []);

  return <div ref={containerRef} />;
}
